import { Col, Row, Tooltip } from "antd";
import React, { useState } from "react";
import SearchControl from "../../../../../../../../components/SearchControls/SearchGroups/SearchControl";
import { CategoryName, CategoryNameHr, ControlType, DataSource } from "../../../../../../../../models";
import { getIconUrl } from "../../../../../../../../services/asset";
import { getWindowWidth, isLargerScreen } from "../../../../../../../../services/utils";

import styles from "./style.scss";
import { Button } from "../../../../../../../../components/Button/Button";

const SearchGroup = props => {
  const { form, groupConfig, isMobile, onSubmit, onReset, showAllControls, setShowAllControls, hideSearchButton } = props;
  const priceFrom = "priceFrom";
  const submitBtn = "submitBtn";
  const brandNewCar = "brandNew";
  const largeWindow = isLargerScreen(getWindowWidth());

  const isCarPage = window.location.pathname.includes(CategoryNameHr.car);
  const isMotorbikePage = window.location.pathname.includes(CategoryNameHr.motorbike);
  const isCommercialVehiclePage = window.location.pathname.includes(CategoryNameHr.commercialVehicle);

  const handleSubmit = () => {
    const { onSubmit } = props;

    onSubmit();
  };

  const renderSearchBtn = onClick => {
    return (
      <Button
        type="primary"
        className={`uppercase ${styles.searchButton}`}
        onClick={onClick}
      >
        <img
          alt={"Traži"}
          src={getIconUrl("search-white.svg")}
        />
        {"Traži"}
      </Button>
    );
  };

  const returnColumnWidthCars = control => {

    if (control.type == ControlType.inputLocation) {
      return showAllControls ? 6 : 4;
    }
    if (control.dataSource == DataSource.make) {
      return showAllControls ? 24 : 8;
    }

    if (control.type == ControlType.range) {
      return showAllControls ? 12 : 8;
    }

    if (control.type == ControlType.multiSelector) {
      return showAllControls ? 6 : 4;
    }

    if (control.type == ControlType.checkbox) {
      return showAllControls ? 6 : (largeWindow ? 4 : 6);
    }

    if (control == submitBtn) {
      return largeWindow ? 4 : 6
    }

    // Default for any other control type (e.g. SingleSelector) — without
    // this, antd Col falls back to a full-width span and breaks the grid.
    return showAllControls ? 6 : 4;
  };

  const returnColumnWidthOther = control => {
    if (control.dataSource == DataSource.make) {
      return 12;
    }

    if (control.type == ControlType.range) {
      return 12;
    }

    return 6;
  };

  const returnColumnWidthMotorbike = (control) => {
    // MultiSelector column
    if (control.type == ControlType.multiSelector) {
      return 6;
    }
    // Price and Location fields
    if (control.fromField == priceFrom || control.type == ControlType.inputLocation) {
      return 6
    }

    // the rest
    return 12;

  };

  return (
    <Row type="flex" gutter={10} style={{ width: "100%" }}>
      {groupConfig.controls.map((controlConfig, index) => {

        return <Col
          key={index}
          className={isCarPage ? (
            (controlConfig.field === brandNewCar && showAllControls) ? styles.clearBoth
              : styles.col)
            : styles.colOther}
          span={
            isCarPage ? returnColumnWidthCars(controlConfig)
              : isMotorbikePage ? returnColumnWidthMotorbike(controlConfig)
                : isCommercialVehiclePage ? 12
                  : returnColumnWidthOther(controlConfig)
          }
        >
          <SearchControl
            controlConfig={controlConfig}
            form={form}
            isMobile={isMobile}
            isSearch={true}
            isColumn={false}
            key={index}
            onSubmit={onSubmit}
            showAllControls={showAllControls}
            setShowAllControls={setShowAllControls}
            showPlaceholder={true}
          />
        </Col>
      }
      )}
      {!showAllControls && !hideSearchButton && (
        <Col span={isCarPage ? returnColumnWidthCars(submitBtn) : 6} className={styles.searchBtnCol}>
          {onReset && (
            <Tooltip title="Resetiraj filtere">
              <span className={styles.resetBtn} onClick={onReset}>
                <img alt="Resetiraj" src={getIconUrl("reload.svg")} />
              </span>
            </Tooltip>
          )}
          {renderSearchBtn(handleSubmit)}
        </Col>
      )}
    </Row>
  );
};

export default SearchGroup;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/FilterSection/SearchControls/SearchGroups/SearchGroup/index.tsx